/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import PaymentIcon from '@mui/icons-material/Payment';
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    TextField,
} from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import SendPayout from "../../../Modals/sendPayout";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const VendorPayouts = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };


    const payoutData = [
        {
            vendorId: "VND-001",
            period: "Jan 2025",
            subscriptionType: "Premium",
            orders: 18,
            grossAmount: "AED 3,200",
            commissionRate: "10%",
            commission: "AED 320",
            netAmount: "AED 2,880",
            status: "Completed",
            statusClass: "success",
        },
        {
            vendorId: "VND-002",
            period: "Jan 2025",
            subscriptionType: "Standard",
            orders: 9,
            grossAmount: "AED 1,450",
            commissionRate: "10%",
            commission: "AED 145",
            netAmount: "AED 1,305",
            status: "Pending",
            statusClass: "warning",
        },
    ];

    const scheduledPayouts = [
        {
            id: "SCH-001",
            vendor: "ABC Electronics",
            subscriptionType: "Premium",
            plan: "Weekly Payout",
            commissionRate: 8,
            amount: "AED 400",
            expiry: "2025-12-31",
            status: "Pending",
        },
        {
            id: "SCH-002",
            vendor: "Fashion Hub",
            subscriptionType: "Standard",
            plan: "Monthly Payout",
            commissionRate: 10,
            amount: "AED 400",
            expiry: "2025-06-30",
            status: "Pending",
        },
    ];

    const vendorBalances = [
        {
            id: "BAL-001",
            vendorId: "VND-1001",
            vendorName: "ABC Electronics",
            subscriptionType: "Premium",
            commissionRate: "8%",
            pendingAmount: "AED 4,250.00",
            lastPayout: "AED 12,800.00",
            lastPayoutDate: "15 Mar 2025",
            status: "Pending",
            statusClass: "warning",
        },
        {
            id: "BAL-002",
            vendorId: "VND-1002",
            vendorName: "Fashion Hub",
            subscriptionType: "Standard",
            commissionRate: "10%",
            pendingAmount: "AED 0.00",
            lastPayout: "AED 9,500.00",
            lastPayoutDate: "10 Mar 2025",
            status: "Settled",
            statusClass: "success",
        },
    ];

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            <div className="main_title">
                <h1> Vendor Payouts</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Vendor Payouts
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* TOTAL PAYOUTS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 0.00
                            <p>Total Payouts</p>
                        </h2>
                        <figure className="blue">
                            <AttachMoneyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* COMPLETED */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Completed</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* PENDING */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Pending</p>
                        </h2>
                        <figure className="warning">
                            <AccessTimeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* ACTIVE SCHEDULES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Active Schedules</p>
                        </h2>
                        <figure className="purple">
                            <EventOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

            </div>
            <Box className="custom_tabs mt_20">
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    className="custom_tabs_links"
                >
                    <Tab label="Payout History" {...a11yProps(0)} />
                    <Tab label="Schedules" {...a11yProps(1)} />
                    <Tab label="Balances" {...a11yProps(2)} />
                </Tabs>

            </Box>
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards ">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search vendor or period..."
                                        />
                                    </Box>
                                </div>
                            </div>

                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Vendor ID</TableCell>
                                            <TableCell>Period</TableCell>
                                            <TableCell>Orders</TableCell>
                                            <TableCell>Subscription</TableCell>
                                            <TableCell>Commission (%)</TableCell>

                                            <TableCell>Commission</TableCell>
                                            <TableCell>Net Amount</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {payoutData.map((row, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell>
                                                    <b>{row.vendorId}</b>
                                                </TableCell>

                                                <TableCell>{row.period}</TableCell>

                                                <TableCell>{row.orders}</TableCell>


                                                <TableCell>
                                                    {row.subscriptionType}
                                                </TableCell>

                                                <TableCell>{row.commissionRate}</TableCell>

                                                <TableCell>{row.commission}</TableCell>

                                                <TableCell>
                                                    <b>{row.netAmount}</b>
                                                </TableCell>

                                                <TableCell>
                                                    <span className={`badge1 ${row.statusClass}`}>
                                                        {row.status}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <Box>
                                                            <IconButton onClick={() => navigate("view-payout")}>
                                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                                            </IconButton>
                                                        </Box>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={valueTabs} index={1}>
                <div className="table_flex">
                    <div className="lt">
                        <div className="cards form">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search vendors..."
                                        />
                                    </Box>
                                </div>
                            </div>

                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Sr. No</TableCell>
                                            <TableCell>Vendor Name</TableCell>
                                            <TableCell>Payout Schedule</TableCell>
                                            <TableCell>Subscription</TableCell>

                                            <TableCell>Commission Rate (%)</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Expiry Date</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Action</TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {scheduledPayouts.map((item, index) => (
                                            <TableRow key={item.id} hover>
                                                {/* Sr No */}
                                                <TableCell>{index + 1}</TableCell>

                                                {/* Vendor */}
                                                <TableCell>
                                                    <b>{item.vendor}</b>
                                                </TableCell>

                                                {/* Schedule Type */}
                                                <TableCell>
                                                    <span className="badge1 info">
                                                        {item.plan}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    {item.subscriptionType}
                                                </TableCell>
                                                {/* Commission Rate */}
                                                <TableCell>{item.commissionRate}</TableCell>

                                                <TableCell>
                                                    {item.amount}
                                                </TableCell>

                                                {/* Expiry */}
                                                <TableCell>
                                                    <TextField
                                                        type="date"
                                                        defaultValue={item.expiry}
                                                        fullWidth
                                                        hiddenLabel
                                                        size="small"
                                                    />
                                                </TableCell>

                                                {/* Actions */}
                                                <TableCell>
                                                    {item.status}
                                                </TableCell>
                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <Box>
                                                            <IconButton onClick={() => navigate("view-payout")}>
                                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                                            </IconButton>
                                                        </Box>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={valueTabs} index={2}>
                <div className="table_flex">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search vendor or vendor ID..."
                                        />
                                    </Box>
                                </div>
                            </div>

                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Vendor ID</TableCell>
                                            <TableCell>Vendor Name</TableCell>
                                            <TableCell>Pending Amount</TableCell>
                                            <TableCell>Subscription</TableCell>
                                            <TableCell>Commission (%)</TableCell>

                                            <TableCell>Last Payout</TableCell>
                                            <TableCell>Last Payout Date</TableCell>

                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {vendorBalances.map((item) => (
                                            <TableRow key={item.id} hover>
                                                {/* Vendor ID */}
                                                <TableCell>
                                                    <b>{item.vendorId}</b>
                                                </TableCell>

                                                {/* Vendor Name */}
                                                <TableCell>
                                                    <b>{item.vendorName}</b>
                                                </TableCell>

                                                {/* Pending Amount */}
                                                <TableCell>
                                                    <b className="text_warning">{item.pendingAmount}</b>
                                                </TableCell>
                                                <TableCell>
                                                    {item.subscriptionType}
                                                </TableCell>

                                                <TableCell>{item.commissionRate}</TableCell>

                                                {/* Last Payout */}
                                                <TableCell>{item.lastPayout}</TableCell>

                                                {/* Last Payout Date */}
                                                <TableCell>{item.lastPayoutDate}</TableCell>

                                                {/* Status */}

                                                <TableCell>
                                                    <div className="table_actions v2">
                                                        <Box>
                                                            <IconButton onClick={() => navigate("view-payout")}>
                                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                                            </IconButton>
                                                        </Box>
                                                        <Box>
                                                            <IconButton onClick={() => setOpenModal(true)}>
                                                                <PaymentIcon />
                                                            </IconButton>
                                                        </Box>

                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <SendPayout
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />

        </>
    )
};
export default VendorPayouts;